import usersApi from './usersApi';
import networkLocationsApi from "./networkLocationsApi";

const adminApi = {
  users: usersApi,
  networkLocations: networkLocationsApi,
};

export default adminApi;
